import { Component, EventEmitter, Output, Input, OnInit  } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AddBeneficiaryComponent } from '../add-beneficiary/add-beneficiary.component';
import { RecipientCriptoService } from 'src/app/dashboard/services/recipient-cripto.service';
import { Subscription } from 'rxjs';
import { AppState } from 'src/app/app.reducer';
import { Store } from '@ngrx/store';
import { BeneficiarioCriptomoneda } from 'src/app/dashboard/interfaces/beneficiario-criptomoneda.interface';
import { MediosCriptoService } from 'src/app/dashboard/services/medios-cripto.service';
import {
  avisoRedesPausadas,
  beneficiarioPausado,
  EstadoRed,
  etiquetaCortaRed,
  redDeBeneficiario,
} from 'src/app/shared/utils/red-cripto';

@Component({
  selector: 'app-beneficiary',
  templateUrl: './beneficiary.component.html',
  styleUrls: ['./beneficiary.component.sass']
})
export class BeneficiaryComponent implements OnInit{

  public subscription: Subscription = new Subscription();
  public user: any;
  public searchTxt: string = '';
  public wordFilter: string = '';

  /**
   * Encendida/pausada de cada red. La compra CLP→USDT acepta beneficiarios de
   * todas las redes (las que no son TRC20 las paga un operador a mano), así
   * que acá importan todas.
   */
  public estadoRedes: EstadoRed[] = [];

  constructor(
    private dialog: MatDialog,
    private recipientcriptoservice: RecipientCriptoService,
    private store: Store<AppState>,
    private mediosCripto: MediosCriptoService,
  ){}

  ngOnInit(): void {
    this.subscription.add(
      this.store.select('auth').subscribe(({ user }: any) => {
        this.user = user;
        this.getBeneficiarios();
      })
    );
    void this.cargarRedes();
  }

  @Output()
  public changeStep = new EventEmitter<number>();

  @Output()
  public beneficiarioOutput = new EventEmitter<BeneficiarioCriptomoneda>();

  @Output()
  public goBack = new EventEmitter<any>();

  public beneficiarioEscogido:BeneficiarioCriptomoneda | undefined = undefined;

  public listaBeneficiarios:BeneficiarioCriptomoneda[] = [];
  public listaBeneficiariosFiltrados:BeneficiarioCriptomoneda[] = [];

  /** Franja de redes pausadas, o null si están todas activas. */
  get avisoRedes(): string | null {
    return avisoRedesPausadas(this.estadoRedes);
  }

  /** Un beneficiario de una red pausada se ve, pero no se puede elegir. */
  pausado(beneficiario: BeneficiarioCriptomoneda): boolean {
    return beneficiarioPausado(beneficiario, this.estadoRedes);
  }

  etiquetaRed(beneficiario: BeneficiarioCriptomoneda): string {
    return etiquetaCortaRed(redDeBeneficiario(beneficiario), beneficiario.medioCriptomoneda_descripcion);
  }

  openCreateDialog(){

    const isMobile = window.innerWidth < 768;
    const dialogRef = this.dialog.open(AddBeneficiaryComponent, {
      data: {
        userID: this.user?.usuarioId,
        type: 'CREATE',
      },
      disableClose: true,
      panelClass: 'aguacate-dialog',
      maxWidth: isMobile ? '95vw' : '560px',
      minWidth: isMobile ? '90vw' : '500px',
      maxHeight: '90vh',
    });

    dialogRef.afterClosed().subscribe(async result => {
      if(result == true ){
        this.getBeneficiarios();
      }
      // El diálogo pudo enterarse de una red recién pausada (422): la franja
      // y la lista lo reflejan sin esperar a que venza la caché.
      void this.cargarRedes();
    })

  }

  clearInput() {
    this.searchTxt = '';
  }

  elegir( beneficiario: BeneficiarioCriptomoneda ):void{
    if (this.pausado(beneficiario)) {
      return;
    }
    if(this.beneficiarioEscogido === beneficiario ){
      this.beneficiarioEscogido = undefined;
      return;
    }
    this.beneficiarioEscogido = beneficiario;
  }

  emitChangeStep( ): void{
    if (!this.beneficiarioEscogido || this.pausado(this.beneficiarioEscogido)) {
      return;
    }
    this.changeStep.emit( 3 );
    this.beneficiarioOutput.emit( this.beneficiarioEscogido );
  }

  async getBeneficiarios(): Promise<void>{
    this.listaBeneficiarios = await this.recipientcriptoservice.getByUser(this.user?.usuarioId);
    this.listaBeneficiariosFiltrados = this.listaBeneficiarios;
    this.soltarSiPausado();
  }

  /**
   * Estado de las redes. `listar()` nunca rechaza: si Nest no responde, todas
   * cuentan como activas y el que decide es wallet-back al crear (422).
   */
  async cargarRedes(): Promise<void> {
    this.estadoRedes = await this.mediosCripto.listar();
    this.soltarSiPausado();
  }

  /** Si lo elegido quedó en una red pausada, se suelta: no se puede continuar con él. */
  private soltarSiPausado(): void {
    if (this.beneficiarioEscogido && this.pausado(this.beneficiarioEscogido)) {
      this.beneficiarioEscogido = undefined;
    }
  }

  buscar(event: KeyboardEvent): void {
    var searchWord = this.searchTxt.toLowerCase();
    if(searchWord === '') {
      this.listaBeneficiariosFiltrados = this.listaBeneficiarios;
      return;
    }
    this.listaBeneficiariosFiltrados = this.listaBeneficiarios.filter( beneficiario => {
      let nombreCompleto = beneficiario.beneficiario_nombre + " " + beneficiario.beneficiario_apellido;
      return nombreCompleto.toLowerCase().includes(searchWord.toLowerCase());
    }
    )
  }

  goToBack(): void {
    this.goBack.emit();
  }

}
